<template>
  <modal width="30%" :title="$t(title)" :visible.sync="isShowDialog">
    <el-form ref="form" :model="dioForm" label-width="120px">
      <el-form-item :label="$t('public.table_scope')">
        <el-select v-model="dioForm.sceneId" style="width:250px">
          <el-option
            v-for="item in scopeArray"
            :key="item.sceneId"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <div slot="footer">
      <el-button type="primary" @click="isShowDialog = false"
        >{{ $t('public.btn_close') }}
      </el-button>
      <el-button type="primary" @click="handleSave"
        >{{ $t('public.btn_confirm') }}
      </el-button>
    </div>
  </modal>
</template>

<script>
import { updateCustomer } from '@/api/modules/display'

export default {
  props: ['isShowEditShow', 'scopeArray', 'choozeScopeId'],
  computed: {
    isShowDialog: {
      get: function () {
        return this.isShowEditShow
      },
      set: function (val) {
        this.$emit('update:isShowEditShow', val) // 可以优化成model  或者minx
      }
    }
  },
  data () {
    return {
      title: $t('integration.modify_customer'),
      dioForm: {
        ids: null,
        sceneId: null
      }
    }
  },
  methods: {
    handleSave () {
      updateCustomer(this.dioForm).then(async ({ state }) => {
        await this.$resultHandle(state)
        this.isShowDialog = false
        this.$parent.getListFn()
      })
    }
  }
}
</script>

<style></style>
